import { useLayoutEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import { useAuth } from "contexts/auth-context"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { useAuditLogContext } from "contexts/audit-log-context"
import moment from "moment"

export default function Create({ title }) {
  const { user } = useAuth()
  const { cache } = useSWRConfig()
  const { queueAuditLog } = useAuditLogContext()
  const { setTransition } = usePage()

  const location = useLocation()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
  }, [location.state?.transition, setTransition])

  const handleSubmit = (data) => {
    nProgress.start()
    toast.loading("Loading", { id: "submit" })

    const url = `${process.env.REACT_APP_INVENTORY_API_URL}/stock/transfer`

    // payload untuk audit log (readable)
    const auditLogPayload = {
      from_outlet_id: data.from_outlet_id,
      from_outlet_name: data.from_outlet_name,
      to_outlet_id: data.to_outlet_id,
      to_outlet_name: data.to_outlet_name,
      delivery_order_no: data.delivery_order_no,
      items: data.items,
      created_by: user?.name
    }

    // payload actual ke API
    const formPayload = {
      from_outlet_id: data.from_outlet_id,
      to_outlet_id: data.to_outlet_id,
      from_outlet_name: data.from_outlet_name,
      to_outlet_name: data.to_outlet_name,
      delivery_order_no: data.delivery_order_no,
      items: data.items,
      created_by: user?.name
    }

    axios.post(url, formPayload).then((response) => {
      // audit log
      queueAuditLog(
        url,
        response.config.method.toUpperCase(),
        "Create Stock Transfer",
        user?.name,
        auditLogPayload,
        null,
        moment().format("YYYY-MM-DD HH:mm:ss"),
        response.status
      )

      // Clear SWR cache biar list refresh
      cache.clear()

      // Navigate ke list
      navigate({ pathname: "/stock-transfer" })

      // Toast success
      toast.success(response.data.message || "Transfer draft created", { id: "submit" })
    }).catch((error) => {
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {})
      }

      toast.error(error?.response?.data?.message || "Failed", {
        ariaProps: { superscript: error?.response?.status },
        id: "submit"
      })
    }).finally(() => {
      nProgress.done()
    })
  }

  return (
    <Form errors={errors} onSubmit={handleSubmit} />
  )
}
